<template>
    <div class="enigma-body"
            :class="enigma.status">
            <div class="enigma-container">
                <enigma-suggestion 
                    v-if="input" 
                    :index="index" 
                    @openEnigma="suggestionToggle(true)"
                    :enigma="enigma"></enigma-suggestion>
                <div class="enigma" v-if="!input">
                    <div class="enigma-text" 
                        :style="{
                            'color' : colors.theme == 'dark' ? `#697582` : `#697582`
                        }"
                    >
                        {{ enigma.enigma }}
                    </div>
                    <div class="button-suggetions" @click="suggestionToggle()">
                        <button-default buttonType="sugestion" :textButton='$t("components.EnigmaToggle.EnigmaBody.textButton")'></button-default>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import ButtonDefault from '../../Buttons/ButtonDefault'
import EnigmaSuggestion from './EnigmaSuggestion'
export default {
    data(){
        return{
            input : false,
            suggestions : false,
            colors:{}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },    
    components: {
        ButtonDefault,
        EnigmaSuggestion
    },
    props: {
        index: {
            
        },
        enigma: {
            required : true
        }
    },
    methods: {
        suggestionToggle(boolean){
            this.input = !boolean
        }
    }
}
</script>
<style lang="scss" scoped>

    .enigma-body{

        // background-color: #d5fcfa;

        .enigma-container{

            width: 80%;
            margin: 10% auto;;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: justify;

            .enigma{

                display: flex;
                flex-direction: column;
                align-items: center;

                .enigma-text{

                    color: rgb(44, 44, 44);
                    font-weight: 600;
                    font-size: 1em;
                    margin: 8% 0 8%;
                    text-align: center;
                }

                .button-suggetions{
                    width: 275px;
                    min-width: 200px;
                }
            }
        }
    }

    .enigma-open{
        z-index: 1;
        overflow: hidden;
        height: calc(90vh - 180px);
        transition-duration: 300ms;
        overflow-y: scroll;
        padding-bottom: 5%;
    }

    .enigma-closed{
        z-index: 1;
        overflow: hidden;
        height: 0px;
        transition-duration: 300ms;
    }

    @media only screen and (min-width : 750px) {
        .enigma-body .enigma-container {
            width: 60%;
            height: 100%;
            justify-content: center;

            .suggestion{

                .rules-suggestion{

                    margin-bottom: 6%;
                }

                .suggestion-input{

                    padding: 2%;
                    margin-bottom: 6%;
                }
            }

            .enigma{

                .enigma-text{

                    margin: 6% 0 6%;
                    font-size: 1em;
                }
            }
        }

        .enigma-open{
            z-index: 1;
            overflow: hidden;
            height: calc(100% - 55px);
            transition-duration: 10ms;
            overflow-y: auto;
            padding-bottom: 5%;
        }

        .enigma-closed{
            z-index: 1;
            overflow: hidden;
            height: 0px;
            transition-duration: 10ms;
        }
    }

    @media only screen and (max-width : 350px) {
        .enigma-body{
            .enigma-container{
                .enigma{
                    .enigma-text{
                        margin: 5% 0 5%;
                    }
                }
            }
        }
    }

    @media only screen and (min-height : 650px) {
        .enigma-body{
            .enigma-container{
                .enigma{
                    .enigma-text{
                        font-size: 19px;
                    }
                }
            }
        }
    }

    @media only screen and (max-height : 320px) {
        .enigma-body.enigma-open{
            z-index: 1;
            overflow: hidden;
            transition-property: height;
            height: calc( 100vh - 100px );
            transition-duration: 500ms;
        }
    }

    

    

    
    
</style>
